export const HostSex = {
  Man: "male",
  Woman: "female"
};
